import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';

import { SessionStorageService } from '@shared/services/storage';
import { Subject } from 'rxjs';
import { ClientService } from '../client/client.service';

@Injectable({providedIn: 'root'})
export class TranslationsService {
  availableTranslations = [...environment.availableLocales];
  langChanged = new Subject<string>();

  constructor(private translate: TranslateService, private storageService: SessionStorageService, private clientService: ClientService) {
  }

  get currentLang() {
    return this.translate.currentLang;
  }

  use(lang = 'pl') {

    this.storageService.setItem('language', lang);
    this.langChanged.next(lang);
    if (this.availableTranslations.includes(lang)) {
      this.translate.use(lang);
    } else {
      if (this.availableTranslations.includes(this.clientService.client.locale)) {
        this.translate.use(this.clientService.client.locale);
      } else {
        this.translate.use('en');
      }
    }
  }
}
